import React, { useCallback, useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber'; //
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { RadioButton } from 'primereact/radiobutton'; //
import { useGetLookUpDropdownListQuery } from '../../../../../../api';
import { DealerAddrDropdown } from './AddrPeportDropdown/DealerAddrDropdown';
import { InterserviceDropdown } from './AddrPeportDropdown/InterserviceDropdown';
import { InterserviceAddrDropdown } from './AddrPeportDropdown/InterserviceAddrDropdown';
import { useLanguage } from '../../../../../../contexts/LanguageContext';
import DealerDropdown from '../../../../../../components/common/DealerDropdown';
import DealerAddressDropdown from '../../../../../../components/common/DealerAddressDropdown';
import { ADDR_REPORT_SELECT_TYPE } from '../../enums/addrReportSelectTypeEnum';

const AddrReportDialog = ({ visible, data, onHide, onSave, dealer }) => {
    const { th, getCurrentLanguageId } = useLanguage();
    const [submitted, setSubmitted] = useState(false);
    const [laborPriceDiffRaw, setLaborPriceDiffRaw] = useState('');

    const { data: selectTypeOptions = [] } = useGetLookUpDropdownListQuery({
        RowCount: 100,
        GroupCode: 'CONTRACTED_SELECT_TYPE',
        LanguageId: getCurrentLanguageId()
    });

    const [formData, setFormData] = useState({
        id: null,
        dealerId: null,
        dealerName: '',
        dealerAddressId: null,
        interserviceId: null,
        interserviceAddressId: null,
        branchSiteAdr: null,
        erpSiteUseId: null,
        selectType: null,
        laborPriceDiff: null
    });
    const isTechnicalSupport = formData.selectType === ADDR_REPORT_SELECT_TYPE.TECHNICAL_SUPPORT;

    useEffect(() => {
        setSubmitted(false);
        setFormData({
            id: data?.id || null,
            dealerId: dealer.id,
            dealerName: dealer.name,
            dealerAddressId: data?.dealerAddressId || null,
            interserviceId: data?.interserviceDealerId || null,
            interserviceAddressId: data?.interserviceDealerAddressId || null,
            branchSiteAdr: data?.branchSiteAdr || null,
            erpSiteUseId: data?.erpSiteUseId || null,
            selectType: Number(data?.selectType ?? 1),
            laborPriceDiff: data?.laborPriceDiff ?? null
        });
    }, [data, visible, dealer]);

    useEffect(() => {
        if (formData.selectType === 2) {
            handleChange('erpSiteUseId', 0);
        } else {
            handleChange('laborPriceDiff', null);
        }
    }, [formData.selectType]);

    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    const handleTechnicalSupportDealerChange = useCallback((selectedDealer) => {
        setFormData((prev) => ({ ...prev, interserviceId: selectedDealer?.id ?? null }));
    }, []);

    const handleTechnicalSupportAddressChange = useCallback((selectedAddress) => {
        setFormData((prev) => ({ ...prev, interserviceAddressId: selectedAddress?.id ?? null }));
    }, []);

    useEffect(() => {
        if (!formData.interserviceId) {
            handleChange('interserviceAddressId', null);
        }
    }, [formData.interserviceId]);

    const handleLaborPriceChange = (raw) => {
    // Sadece rakam, virgül ve noktaya izin ver
    if (raw !== '' && !/^[\d]*[,.]?[\d]*$/.test(raw)) return;

    setLaborPriceDiffRaw(raw);
    const normalized = raw.replace(',', '.');
    const parsed = parseFloat(normalized);
    
    handleChange('laborPriceDiff', isNaN(parsed) ? null : parsed);
};

    const handleSubmit = () => {
        setSubmitted(true);

        const isLaborPriceDiffRequired = formData.selectType === 2;

        if (!formData.interserviceId || !formData.interserviceAddressId || (isLaborPriceDiffRequired && (formData.laborPriceDiff === null || formData.laborPriceDiff === undefined || formData.laborPriceDiff === ''))) {
            return;
        }
        onSave(formData);
        onHide();
    };

    const footer = (
        <div className="flex justify-content-end gap-2">
            <Button label={th('common.cancel')} icon="pi pi-times" outlined onClick={onHide} />
            <Button label={th('common.save')} icon="pi pi-check" onClick={handleSubmit} />
        </div>
    );

    useEffect(() => {
        setLaborPriceDiffRaw(data?.laborPriceDiff != null ? String(data.laborPriceDiff).replace('.', ',') : '');
    }, [data, visible]);

    return (
        <Dialog
            header={data ? th('customerAddressBrand.tabs.addrReport.dialog.title.update') : th('customerAddressBrand.tabs.addrReport.dialog.title.new')}
            visible={visible}
            style={{ width: '45vw' }}
            modal
            onHide={onHide}
            className="p-fluid"
            footer={footer}
        >
            <div className="formgrid grid">
                <div className="field col-12 md:col-6">
                    <label className="font-bold block mb-2">{th('customerAddressBrand.tabs.addrReport.dialog.label.selectType')}</label>

                    <div className="flex align-items-center gap-4 flex-wrap md:flex-nowrap">
                        {selectTypeOptions.map((option) => {
                            const selectType = Number(option.sort);
                            const checked = Number(formData.selectType) === selectType;
                            const id = `selectType_${selectType}`;
                            return (
                                <div key={option.id || option.sort} className="flex align-items-center">
                                    <RadioButton
                                        inputId={id}
                                        name="selectType"
                                        value={selectType}
                                        onChange={(e) => {
                                            const newVal = e.value; // PrimeReact RB: e.value
                                            handleChange('selectType', newVal);
                                            handleChange('interserviceId', null);
                                            handleChange('interserviceAddressId', null);
                                            handleChange('erpSiteUseId', 0);
                                        }}
                                        checked={checked}
                                    />
                                    <label htmlFor={id} className="ml-2">
                                        {option.translatedText}
                                    </label>
                                </div>
                            );
                        })}
                    </div>

                    {submitted && !formData.selectType && <small className="p-error">{th('common.required')}</small>}
                </div>

                <div className="field col-12 md:col-6">
                    <label className="font-bold block mb-2">{th('customerAddressBrand.tabs.addrReport.dialog.label.dealerName')}</label>
                    <InputText value={formData.dealerName} disabled />
                </div>

                <div className="field col-12 md:col-6">
                    <label className="font-bold block mb-2">{th('customerAddressBrand.tabs.addrReport.dialog.label.interservice')}</label>
                    {isTechnicalSupport ? (
                        <DealerDropdown
                            value={formData.interserviceId}
                            onChange={handleTechnicalSupportDealerChange}
                            rowCount={100}
                            placeholder={th('customerAddressBrand.tabs.addrReport.placeholder.selectService')}
                            className={submitted && !formData.interserviceId ? 'p-invalid' : ''}
                        />
                    ) : (
                        <InterserviceDropdown value={formData.interserviceId} selectType={formData.selectType} onChange={(val) => handleChange('interserviceId', val)} className={submitted && !formData.interserviceId ? 'p-invalid' : ''} />
                    )}
                    {submitted && !formData.interserviceId && <small className="p-error">{th('common.required')}</small>}
                </div>

                <div className="field col-12 md:col-6">
                    <label className="font-bold block mb-2">{th('customerAddressBrand.tabs.addrReport.dialog.label.interserviceAddress')}</label>
                    {isTechnicalSupport ? (
                        <DealerAddressDropdown
                            value={formData.interserviceAddressId}
                            dealerId={formData.interserviceId}
                            onChange={handleTechnicalSupportAddressChange}
                            placeholder={th('customerAddressBrand.tabs.addrReport.placeholder.selectServiceAddress')}
                            className={submitted && !formData.interserviceAddressId ? 'p-invalid' : ''}
                        />
                    ) : (
                        <InterserviceAddrDropdown
                            value={formData.interserviceAddressId}
                            onChange={(val) => handleChange('interserviceAddressId', val)}
                            selectType={formData.selectType}
                            className={submitted && !formData.interserviceAddressId ? 'p-invalid' : ''}
                        />
                    )}
                    {submitted && !formData.interserviceAddressId && <small className="p-error">{th('common.required')}</small>}
                </div>

                {formData.selectType === 2 && (
                    <div className="field col-12 md:col-6">
                        <label className="font-bold block mb-2">{th('customerAddressBrand.tabs.addrReport.dialog.label.laborPriceDiff')}</label>
                        <InputText
                            value={laborPriceDiffRaw}
                          onChange={(e) => handleLaborPriceChange(e.target.value)}
                            placeholder="0,00"
                            className={submitted && (formData.laborPriceDiff === null || formData.laborPriceDiff === undefined) ? 'p-invalid' : ''}
                        />
                        {submitted && (formData.laborPriceDiff === null || formData.laborPriceDiff === undefined) && <small className="p-error">{th('common.required')}</small>}
                    </div>
                )}
                {/* {formData.selectType !== 2 && (
                    <>
                        <div className="field col-12 md:col-6">
                            <label className="font-bold block mb-2">{th('customerAddressBrand.tabs.addrReport.dialog.label.dealerAddress')}</label>
                            <DealerAddrDropdown value={formData.erpSiteUseId} onChange={(val) => handleChange('erpSiteUseId', val)} className={submitted && !formData.erpSiteUseId ? 'p-invalid' : ''} />
                            {submitted && !formData.erpSiteUseId && <small className="p-error">{th('common.required')}</small>}
                        </div>
                        <div className="col-12 md:col-6"></div>
                    </>
                )} */}
            </div>
        </Dialog>
    );
};

export default AddrReportDialog;
